import { toast } from 'react-toastify'
import {
  getAllTrainigRecords,
  getAllTrainigRecordsCategories,
  getTraningRecordById,
} from '../../api/admin/trainingRecord'
import {
  traningCategoriesResponse,
  traningCategoriesResponseObj,
  traningTrackingRecord,
  traningTrackingRecordResponse,
  traningTrackingRecordResponseCountObj,
  traningTrackingRecordResponseObj,
} from '../../utils/types'

export const getTraningRecord = async (
  data: string[],
  // currentPage: number,
  sortBy: string,
  sortOrderValue: string
): Promise<traningTrackingRecordResponseCountObj> => {
  const response = (await getAllTrainigRecords(
    data,
    // currentPage,
    sortBy,
    sortOrderValue
  )) as traningTrackingRecordResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getCategories = async (
  // currentPage: number,
  sortBy: string,
  sortOrderValue: string
): Promise<traningCategoriesResponseObj> => {
  const response = (await getAllTrainigRecordsCategories(
    // currentPage,
    sortBy,
    sortOrderValue
  )) as traningCategoriesResponse

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}

export const getTraningById = async (
  id: string,
  schoolId: string | undefined
): Promise<traningTrackingRecord> => {
  const response = (await getTraningRecordById(
    id,
    schoolId
  )) as traningTrackingRecordResponseObj

  if (response?.status != 'successful') {
    toast.error('Network Error.', {
      position: 'top-right',
    })
  }
  return response?.data
}
